import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Container, Spinner } from 'react-bootstrap';
import { ArrowLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import { supabase } from '../lib/supabaseClient';
import { fetchProfileLookups, hydrateProfile } from '../lib/profileLookups';

function NotFoundPage() {
  const navigate = useNavigate();

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadProfile = useCallback(async () => {
    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (!user) {
      navigate('/');
      return;
    }

    const { data } = await supabase
      .schema('akreditasi')
      .from('profiles')
      .select('*')
      .eq('user_id', user.id)
      .maybeSingle();

    if (data) {
      try {
        const lookups = await fetchProfileLookups(supabase);
        setProfile(hydrateProfile(data, lookups));
      } catch {
        setProfile(data);
      }
    } else {
      setProfile(null);
    }
    setLoading(false);
  }, [navigate]);

  useEffect(() => {
    loadProfile();
  }, [loadProfile]);

  const goHome = () => {
    if (profile?.role === 'superadmin') {
      navigate('/superadmin');
      return;
    }

    navigate('/dashboard');
  };

  if (loading) {
    return (
      <DashboardLayout
        title="Halaman Tidak Ditemukan"
        breadcrumbs={['Dashboard', '404']}
        profile={profile}
        activeMenu="dashboard"
      >
        <div className="page-loading-v2">
          <Spinner animation="border" />
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout
      title="Halaman Tidak Ditemukan"
      breadcrumbs={['Dashboard', '404']}
      profile={profile}
      activeMenu="dashboard"
    >
      <Container fluid className="p-0">
        <Card className="notfound-card">
          <Card.Body>
            <div className="notfound-code">404</div>
            <h2>Halaman tidak ditemukan</h2>
            <p>
              Alamat yang dibuka tidak tersedia atau sudah dipindahkan. Silakan
              kembali ke dashboard utama sistem akreditasi.
            </p>
            <div className="notfound-actions">
              <Button className="save-btn-v2" onClick={goHome}>
                <Home size={16} className="me-2" />
                Kembali ke Dashboard
              </Button>
              <Button variant="outline-secondary" onClick={() => navigate(-1)}>
                <ArrowLeft size={16} className="me-2" />
                Kembali
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </DashboardLayout>
  );
}

export default NotFoundPage;
